import React from "react";
import {Container} from "react-bootstrap";

function Bio() {
    return (
        <Container>
            <div className="row">
                <div className="col-md-8 offset-md-2">
                    <h1 className="text-center">Concerning Porters</h1>
                    <hr />
                    <p>
                        Porter James is a human currently stranded in Silver Spring, MD.
                    </p>
                    <img src="/assets/images/porter-in-hokkaido.jpg"
                         className="img-with-margin"
                         title="Porter Flooshyhair"
                         alt="Porter with flooshy hair"
                    />
                    <br/>
                    <p>
                        A <strong>Data Engineer</strong> by profession,
                        Porter is committed to tricking his employers into using data to make decisions.
                        The current subject of this prankery is <a href="https://www.collegevine.com">CollegeVine</a>,
                        a company that helps connect high school students with colleges.
                    </p>
                    <p>
                        When not busy munging data, Porter is
                        a <strong>composer</strong>, <strong>poet-and-he-knows-it</strong>,
                        and even occasionally <strong>does an art or two</strong>.
                    </p>
                    <p>
                        Porter is also somewhat obsessive about <strong>language acquisition</strong>, most recently
                        studying Mandarin (he also speaks Spanish, and a bit of Cebuano and Tagalog).
                    </p>
                    <p>
                        He is the proud guardian of
                        an <a href="https://en.wikipedia.org/wiki/Askal">Aspin dog</a> named <strong>Banana</strong>, as
                        well as being the temporary custodian of <strong>Finn the Cat</strong>, who is a cat named Finn.
                    </p>
                    <img src="/assets/images/i-want-a-chicken.jpg"
                         className="img-with-margin"
                         title="I want a chicken."
                         alt="A dog that wants chicken."
                    />
                    <img src="/assets/images/cat-on-table.jpg"
                         className="img-with-margin"
                         title="I also want chicken."
                         alt="A cat that also wants chicken."
                    />
                </div>
            </div>
        </Container>
    );
}

export default Bio;